import { render, staticRenderFns } from "./servicelist.vue?vue&type=template&id=5749070f&scoped=true&"
import script from "./servicelist.vue?vue&type=script&lang=js&"
export * from "./servicelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5749070f",
  null
  
)

export default component.exports